import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { Row, Col } from "antd";
import { CloseOutlined, EditOutlined } from "@ant-design/icons";
import { BasicModal } from "@life-line-lab/components-react";
import DeliveryDateModal from "Components/order-management/shared/parcel-modals/delivery-date-modal";

const initialModal: any = {
  open: false,
};

const ParcelTrackingDropoffViewComponent = ({
  parcelDetails,
  customerName,
  dropoffLocationName,
  onUpdateDeliveryDate,
  isLoading,
}) => {
  const { t } = useTranslation();
  const history = useHistory();

  const [callModal, setCallModal] = useState<any>(<></>);
  const [modal, setModal] = useState<any>(initialModal);
  const [error, setError] = useState<any>({});

  const onBack = () => {
    history.goBack();
  };

  const handleResetModalState = () => {
    setModal(initialModal);
  };

  const handleOnUpdateDeliveryDate = async (data) => {
    const isSuccess = await onUpdateDeliveryDate(data);

    if (isSuccess) {
      handleResetModalState();
    } else {
      setError((prev) => ({
        ...prev,
        general: "Failed to update delivery date",
      }));
    }
  };

  const modalProps = {
    onSubmit: handleOnUpdateDeliveryDate,
    onClose: handleResetModalState,
    error,
    setError,
    isLoading,
  };

  const handleEditDeliveryDate = (id: string, value: string) => {
    if (!value) return;
    if (!id) return;

    const date = moment(value);

    setCallModal(
      <DeliveryDateModal
        {...modalProps}
        initialDeliveryDate={date}
        orderID={id}
      />,
    );
    setModal((prev) => ({ ...prev, open: true, orderID: id }));
  };

  return (
    <div>
      <div className="dm-put-container drop-off">
        <div className="dm-put-header">
          <div className="put-title">{parcelDetails?.dropOffCode}</div>
          <div className="put-close">
            <CloseOutlined
              style={{ fontSize: "20px" }}
              onClick={() => {
                onBack();
              }}
              className="cursor-pointer back-action right"
            />
          </div>
        </div>
        <div className="dm-divider"></div>
        <div className="dm-put-content">
          <div className="dm-put-content-inner">
            <Row gutter={[0, 16]}>
              <Col span={6}>
                <div className="dm-put-content-col">
                  <label className="title"> {t("label.dropoffDate")} </label>
                  <div>
                    {parcelDetails?.dropOffDate?.substr(
                      0,
                      parcelDetails.dropOffDate.indexOf("T"),
                    ) || "none"}
                  </div>
                </div>
              </Col>
              <Col span={6}>
                <div className="dm-put-content-col">
                  <label className="title"> {t("label.noOfParcel")} </label>
                  <div>{parcelDetails?.parcelList?.length || "none"}</div>
                </div>
              </Col>
              <Col span={6}>
                <div className="dm-put-content-col">
                  <label className="title"> {t("label.customer")} </label>
                  <div>{customerName || "none"}</div>
                </div>
              </Col>
              <Col span={6}>
                <div className="dm-put-content-col">
                  <label className="title">
                    {" "}
                    {t("label.dropoffLocation")}{" "}
                  </label>
                  <div>{dropoffLocationName || "none"}</div>
                </div>
              </Col>
              <Col span={6}>
                <div className="dm-put-content-col">
                  <label className="title">
                    {" "}
                    {t("label.noOfDriverExpected")}{" "}
                  </label>
                  <div>{parcelDetails?.noOfDrivers || "none"}</div>
                </div>
              </Col>
              <Col span={6}>
                <div className="dm-put-content-col">
                  <label className="title">
                    {" "}
                    {t("label.estTimeOfDropoff")}{" "}
                  </label>
                  <div>
                    {moment(parcelDetails?.dropOffTimeFrom).format("hh:mm a") ||
                      "none"}
                  </div>
                </div>
              </Col>
              <Col span={6}>
                <Row gutter={[0, 8]}>
                  <Col span={24}>
                    <label className="title"> {t("label.deliveryDate")} </label>
                  </Col>
                  <Col span={24}>
                    {parcelDetails?.deliveryDate && (
                      <div className="pov-edit-container">
                        <div>
                          {moment(parcelDetails?.deliveryDate).format(
                            "DD-MM-YYYY",
                          ) || "-"}
                        </div>
                        <span
                          className="pov-edit"
                          onClick={() =>
                            handleEditDeliveryDate(
                              parcelDetails?._id,
                              parcelDetails?.deliveryDate,
                            )
                          }
                        >
                          <EditOutlined />
                        </span>
                      </div>
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <BasicModal
        className="modal"
        isOpen={modal.open}
        isClosable={true}
        isMaskClosable={false}
        onClose={() => {
          handleResetModalState();
        }}
        width={800}
      >
        {callModal}
      </BasicModal>
    </div>
  );
};

export default ParcelTrackingDropoffViewComponent;
